import { render, staticRenderFns } from "./AccelerationZoneChart.vue?vue&type=template&id=002135d8"
import script from "./AccelerationZoneChart.vue?vue&type=script&lang=js"
export * from "./AccelerationZoneChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports